import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import "./App.css";

function ProductCard({ product }) {
  const { addToCart } = useContext(CartContext);
  const isOnSale = product.on_sale && product.sale_price;

  const handleAddToCart = () => {
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      qty: 1,
      images: product.images,
    });
  };

  return (
    <div className="product-card">
      {/* Image clickable */}
      <Link to={`/product/${product.id}`} className="image-wrapper">
        {product.images[0] && (
          <img src={product.images[0].src} alt={product.name} />
        )}
        {isOnSale && (
          <span className="badge-sale">
            {product.percentage_off || "خصم"}
          </span>
        )}
      </Link>

      {/* Title clickable */}
      <h3 className="product-title">
        <Link to={`/product/${product.id}`}>{product.name}</Link>
      </h3>

      {/* Price */}
      <div className="product-price">
        {isOnSale ? (
          <>
            <span className="sale-price">{product.sale_price} KWD</span>
            <span className="regular-price">{product.regular_price} KWD</span>
          </>
        ) : (
          <span className="normal-price">{product.price} KWD</span>
        )}
      </div>

      {/* Add to Cart */}
      {product.type === "simple" ? (
        <button onClick={handleAddToCart} className="add-to-cart">
          إضافة إلى السلة
        </button>
      ) : (
        <Link to={`/product/${product.id}`} className="select-options">
          تحديد أحد الخيارات
        </Link>
      )}
    </div>
  );
}

export default ProductCard;
